export default __webpack_public_path__ + "static/media/456-doc-p2.716ac87d.jpg";